module.exports = __webpack_public_path__ + "img/69.99e4b210.png";